var baseURL = '';
export const environment = {
  production: false,
  name: 'development',
  appConfig: {
    apisBaseUrl: "https://gateway.skfh.dev",
    notificationServiceBaseUrl: "https://notification.skfh.dev",
    awsUrl: "https://mr-oss-dev-01.oss-me-central-1.aliyuncs.com/",
    moyassarPublishableKey: "pk_test_UD2aikfikR8nXZhcynGrBjDZ63dw3Lpcvb9Fwtpi"
  },
  mapKey: "AIzaSyDt-3iS_kTNAHFiFi32b2dSRU8NzlaWR8g",
  sentry: {
    dsn: 'https://809370f28369c54b2aca45e6ed2b1e08@o4510658276163584.ingest.de.sentry.io/4511971104522320',
    enabled: true,
    environment: 'development',
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    debug: true,
  },
};
